module.exports = __webpack_public_path__ + "img/422-560b88.png";